import environment from './dev'
export default environment
